/**
 * Sesotho: Suggest flows with AI
 *
 * What this file covers: Suggest flows with AI: the page where a business gives its ideas, the AI suggests flows from its knowledge base, its Insights report and its flows, asks questions in a chat, and builds only the picked ones (switched off); its settings, models and credits, the AI's live activity and memory.
 *
 * Tone: Clear and encouraging, for business owners planning their chatbot. Say what the AI is doing in plain words; be exact about credits and that nothing is built or switched on without the person.
 *
 * Sesotho: Everyday Sesotho as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const flowIdeas: Catalog = {
};

export default flowIdeas;
